module.exports = __webpack_public_path__ + "img/visa_greyscale.53198d1c.png";